<template>
  <div class="connecting-container">
    <div>
      <img
        class="imageCentered"
        :src="require('@/assets/img/connectionInProgress.png')"
      >
    </div>
    <div class="message">
      <h1>CHI Family is connecting to CHI Servers</h1>
      <p>Please wait...</p>
    </div>
  </div>
</template>

<style></style>

<script>
import * as Sentry from '@sentry/vue'
export default {
  name: 'ConnectingLoader',
  methods: {
    goHome: function () {
      this.$router.push({ name: 'Homepage' }).catch(error => {
        Sentry.captureException(error)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.message {
  h1,
  p {
    color: #2b3e6e;
    font-size: 18px;
    font-weight: 400;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ConnectingLoader.vue